'use es6';

const configureEntries = mapping => entries => {
  return entries.map(entry => {
    const property = entry.get('property');
    return mapping.has(property) ? entry.set('property', mapping.get(property)) : entry;
  });
};
export const configureMetrics = mapping => config => config.updateIn(['metrics'], configureEntries(mapping));
export const configureFilters = mapping => config => config.updateIn(['filters', 'custom'], configureEntries(mapping));